import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ScripturePage from "../pages/scripture/page";
import DevotionalsPage from "../pages/devotionals/page";
import LoginPage from "../pages/login/page";
import FavoritesPage from "../pages/favorites/page";
import NotesPage from "../pages/notes/page";
import SettingsPage from "../pages/settings/page";
import ResetPasswordPage from "../pages/reset-password/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/scripture",
    element: <ScripturePage />,
  },
  {
    path: "/devotionals",
    element: <DevotionalsPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/favorites",
    element: <FavoritesPage />,
  },
  {
    path: "/notes",
    element: <NotesPage />,
  },
  {
    path: "/settings",
    element: <SettingsPage />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
